
import mainblock from './mainblock.js'
import minies from './minies.js'
import media from './media.js'

const state = {
           
    color:'#fff',
    name:'Tags',
    minies: false,
    media: false,
    vuexnamespace: 'tags',
    initmutation:'tags/TAG_INIT_TAGS',
    backlink:'supplier',
    duplicateable:true,
    helptext:""
                                                   
    
};

export default {
    namespaced: true,
    modules: {
        mainblock: mainblock,
        minies:minies,
        media:media        
    },
    state,
  
};